import { getAssetUrl } from "@/constant/assets";
import { playCoinSound } from "@/lib/systemSound";

export interface DiamondAnimationOptions {
  start: { x: number; y: number };
  end: { x: number; y: number };
  imageUrl?: string;
  duration?: number;
  repeat?: number;
  interval?: number;
}

export function runDiamondAnimation({
  start,
  end,
  imageUrl = getAssetUrl('assets/diamond-3.png'),
  duration = 2000,
  repeat = 3,
  interval = 250,
}: DiamondAnimationOptions) {
  let count = 0;

  function playOnce() {
    playCoinSound();

    const goldEl = document.createElement('img');
    goldEl.src = imageUrl;
    goldEl.style.width = '40px';
    goldEl.style.height = '40px';
    goldEl.style.position = 'fixed';
    goldEl.style.left = `${start.x}px`;
    goldEl.style.top = `${start.y}px`;
    goldEl.style.transition = `all ${duration / 1000}s cubic-bezier(0.4, 0, 0.2, 1)`;
    goldEl.style.pointerEvents = 'none';
    // goldEl.style.zIndex = '9000';
    document.body.appendChild(goldEl);

    requestAnimationFrame(() => {
      goldEl.style.left = `${end.x}px`;
      goldEl.style.top = `${end.y}px`;
      goldEl.style.transform = 'scale(0.2)';
      goldEl.style.opacity = '0.9';
    });

    setTimeout(() => {
      document.body.removeChild(goldEl);
    }, duration);
  }

  function loop() {
    if (count < repeat) {
      playOnce();
      count++;
      if (count < repeat) {
        setTimeout(loop, interval);
      }
    }
  }

  loop();
}
